import { NotificationSettings } from 'v2/models';
import { TNotificationSettingsFormValues } from './NotificationSettingsForm';

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export const getNotificationSettings = (
  formValues: TNotificationSettingsFormValues
): PartialBy<NotificationSettings, 'id'> => {
  return {
    ...(formValues.id ? { id: formValues.id } : {}),
    email_org: formValues.emailOrg === 'yes' ? true : false,
    email_user: formValues.emailUser === 'yes' ? true : false,
    email_new_for_review_search:
      formValues.emailNewForReviewSearches === 'yes' ? true : false,
    email_new_invoice: formValues.emailNewInvoice === 'yes' ? true : false,
    email_new_provider_response_for_reviewed_requests:
      formValues.emailNewProviderResponseForReviewedRequests === 'yes'
        ? true
        : false,
  };
};

export const getNotificationSettingsFormValues = (
  settings?: NotificationSettings | null
): TNotificationSettingsFormValues => {
  return {
    id: settings?.id || 0,
    emailOrg: settings?.email_org === false ? 'no' : 'yes',
    emailUser: settings?.email_user === false ? 'no' : 'yes',
    emailNewForReviewSearches:
      settings?.email_new_for_review_search === false ? 'no' : 'yes',
    emailNewInvoice: settings?.email_new_invoice ? 'yes' : 'no',
    emailNewProviderResponseForReviewedRequests:
      settings?.email_new_provider_response_for_reviewed_requests
        ? 'yes'
        : 'no',
  };
};
